// src/hooks/usePortalisClientEvent.js
import { useEffect } from 'react';
import { navigate } from 'gatsby';

// Define the hook
const usePortalisClientEvent = (onMobileRedirect) => {
  useEffect(() => {
    const handleMessage = (event) => {
      try {

        const data = event.data;
        // Validate data structure
        if (data && typeof data === 'object' && data.type === 'portalis-client-event') {
          const payload = data.payload;

          // Check for the specific redirect event
          if (payload && payload.eventName === 'redirect' && typeof payload.data === 'string') {
            console.log('Received redirect event via hook, navigating to:', payload.data);
            navigate(payload.data);

            // Optional: Trigger mobile UI behavior if window width < 768 and callback provided
            // Using 768px breakpoint to align with Chatbot.tsx mobile check
            if (window.innerWidth < 768 && typeof onMobileRedirect === 'function') {
              onMobileRedirect();
            }
          }
        }
      } catch (err) {
        console.error('Error processing message event in usePortalisClientEvent:', err);
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup function
    return () => {
      window.removeEventListener('message', handleMessage);
    };
    // Add onMobileRedirect to dependencies
  }, [onMobileRedirect]); // Rerun effect if the callback changes
};

// Export the hook using ESM syntax
export default usePortalisClientEvent; 